@if (content) {
  <div>
    <span [innerHtml]="content"></span>
  </div>
}